<script setup lang="ts">
import { computed, ref } from 'vue';
import { BTextField } from '@/design-system';

type PropsType = {
    modelValue?: string;
    label?: string;
    disabled?: boolean;
    class?: string | string[];
    name?: string;
    dataType?: string;
};

const props = withDefaults(defineProps<PropsType>(), {
    disabled: false,
    dataType: 'string',
});

const emit = defineEmits<{
    'update:modelValue': [value: string | number];
}>();

const isPasswordVisible = ref(false);

const passwordType = computed(() => (isPasswordVisible.value ? 'text' : 'password'));
const passwordIcon = computed(() => (isPasswordVisible.value ? 'mdi-eye-off' : 'mdi-eye'));

const togglePasswordVisibility = () => {
    isPasswordVisible.value = !isPasswordVisible.value;
};

defineOptions({ inheritAttrs: false });
</script>

<template>
    <BTextField
        :model-value="modelValue"
        :label="label"
        :disabled="disabled"
        :type="passwordType"
        :append-inner-icon="passwordIcon"
        :show-required-visual="false"
        :class="props.class"
        :name="name"
        :data-type="dataType"
        required
        v-bind="$attrs"
        @update:model-value="emit('update:modelValue', $event)"
        @click:append-inner="togglePasswordVisibility"
    />
</template>
